import { render, staticRenderFns } from "./SuggestionCategoryPicker.vue?vue&type=template&id=202f911e&scoped=true&"
import script from "./SuggestionCategoryPicker.vue?vue&type=script&lang=js&"
export * from "./SuggestionCategoryPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f911e",
  null
  
)

export default component.exports